﻿import olView, { ViewOptions } from 'ol/View';
import { transformExtent } from 'ol/proj';
import { Projections } from './models/Projections';

export const longitudeExtent: [number, number] = [-540, 540];
export const latitideExtent: [number, number] = [-80, 80];

export const getExtent = (boundaries?: {
    longitude?: [number, number],
    latitide?: [number, number]
}) => {
    let longitude = boundaries?.longitude ?? longitudeExtent;
    let latitide = boundaries?.latitide ?? latitideExtent;
    return [longitude[0], latitide[0], longitude[1], latitide[1]] as [number, number, number, number];
}

class View extends olView {
    constructor(options?: ViewOptions) {
        super({
            extent: transformExtent(getExtent(), Projections.WGS, Projections.WebMercator),
            center: [0, 0],
            zoom: 2,
            minZoom: 2,
            maxZoom: 20,
            constrainResolution: true,
            smoothExtentConstraint: false,
            smoothResolutionConstraint: false,
            showFullExtent: true,
            ...(options ?? {})
        });
    }
}

export default View;